const EVENTS = {
  CLICK: 'click',
  SHARE: 'share',
  LOCATION: 'location',
  IMPRESSION: 'impression',
  EMBED_CTA_CLICK: 'embed-cta-click',
  // Forms
  FORM_SUBMIT: 'form-submit',
  EMAIL_OPT_IN: 'email-opt-in',
  SMS_OPT_IN: 'sms-opt-in',
  // Video
  VIDEO_STARTED: 'video-started',
  VIDEO_ENDED: 'video-ended',
  VIDEO_PLAYING: 'video-playing',
  VIDEO_PAUSED: 'video-paused',
  VIDEO_25_PERCENT_WATCHED: 'video-25-percent-watched',
  VIDEO_50_PERCENT_WATCHED: 'video-50-percent-watched',
  VIDEO_75_PERCENT_WATCHED: 'video-75-percent-watched',
  // Feeds
  FEED_STACK_EXPANSION: 'stack-expansion',
  // Carousel
  CAROUSEL_SWIPE: 'carousel-swipe',
  // Commerce
  TRANSACTION: 'transaction',
  // Shop
  PRODUCT_VIEW: 'product-view',
  ADD_TO_CART: 'add-to-cart',
  BUY_NOW: 'buy-now',
  // Contact details
  DOWNLOAD_VCARD: 'download-vcard',
  // Locked links
  UNLOCKED: 'unlocked',
  // Cover image
  COVER_VIEW: 'cover-view',
  COVER_CLICK: 'cover-click'
};
const EVENT_TO_LABEL = {
  [EVENTS.IMPRESSION]: 'Impression',
  [EVENTS.SHARE]: 'Share Click',
  [EVENTS.LOCATION]: 'Location Click',
  [EVENTS.EMBED_CTA_CLICK]: 'Embed CTA Click',
  [EVENTS.FORM_SUBMIT]: 'Form Submit',
  [EVENTS.EMAIL_OPT_IN]: 'Email Opt-in',
  [EVENTS.SMS_OPT_IN]: 'SMS Opt-in',
  [EVENTS.VIDEO_STARTED]: 'Video Started',
  [EVENTS.VIDEO_ENDED]: 'Video Ended',
  [EVENTS.VIDEO_PLAYING]: 'Video Playing',
  [EVENTS.VIDEO_PAUSED]: 'Video Paused',
  [EVENTS.VIDEO_25_PERCENT_WATCHED]: 'Video 25% Watched',
  [EVENTS.VIDEO_50_PERCENT_WATCHED]: 'Video 50% Watched',
  [EVENTS.VIDEO_75_PERCENT_WATCHED]: 'Video 75% Watched',
  [EVENTS.FEED_STACK_EXPANSION]: 'Feed Stack Expansion',
  [EVENTS.CAROUSEL_SWIPE]: 'Carousel Swipe',
  [EVENTS.TRANSACTION]: 'Transaction',
  [EVENTS.DOWNLOAD_VCARD]: 'Download vCard',
  [EVENTS.UNLOCKED]: 'Unlocked link',
  [EVENTS.COVER_VIEW]: 'Cover Image View',
  [EVENTS.COVER_CLICK]: 'Cover Image Click'
};
export { EVENTS, EVENT_TO_LABEL };